import { useEffect, useState } from 'react';
import { Grid, CircularProgress } from '@mui/material';
import { SeleccionDeMedioDePago } from '../matriculas/seleccionDeMedioDePago';
import { PagoBrick } from '../matriculas/pagoBrick';
import { PagoQR } from '../matriculas/pagoQR';
import { PagoPendiente } from '../matriculas/pagoPendiente';
import { obtenerCalculoTasaCancelacion } from 'app/features/Profesionales/profesionalesAPI';
import Swal from 'sweetalert2';
import { ModalTyCCancelacion } from './ModalTyCCancelacion';
import { useDispatch } from 'react-redux';
import { setEnvioConDeuda } from 'app/features/Cancelacion/envioConDeudaSlice';
import { PagoCompletado } from './PagoCompletado';


export const PagoCancelacion = ({ datos, bloquearBtn, setBloquearBtn, setDatos, setValue, titulosProfesional, setOcultarTabs, loaderBtnGuardar, setLoaderBtnGuardar, idEstado, setIdEstado, ocultarContenido, setOcultarContenido, resultadoPagoTasa, estadoOperacion, obtenerResultadoDePago, setEstadoOperacion, setResultadoPago, montoDeTasa, setMedioDePago, medioDePago, limpiarNotificaciones, contadorNotificacion, debeGenerarNuevoQR, setMontarPdf, confirmarPagoYGenerarPDF, verFormaDePago, enviarSolicitud, enviarSolicitudSinPagar, poseeDeuda, confirmaPago, setConfirmaPago, tramiteTienePagoInicial, tieneDiferenciaEnPago, setTieneDiferenciaEnPago }) => {

    const [tasaRR, setTasaRR] = useState();
    const [loading, setLoading] = useState(false);
    const [banderaOperacion, setBanderaOperacion] = useState(true);
    const tipoUsuario = Number(localStorage.userType);
    const [openConfirmarTerminos, setOpenConfirmacionTerminos] = useState(false);
    const [valorMedioPago, setValorMedioPago] = useState('');
    const [acabaDePagar, setAcabaDePagar] = useState(false);
    const [envioTramiteConDeuda, setEnvioTramiteConDeuda] = useState(false);
    const dispatch = useDispatch();

    const calculoDeTasa = async() => {
        setLoading(true)
        const resp = await obtenerCalculoTasaCancelacion(localStorage.idLegajo, datos.fechaCancelacion);
        setTasaRR({...resp, fecha: datos.fechaCancelacion.replace(/-/g, "/"), montoTramite: resp.montoCancelacion});
        setLoading(false);
    }

    const montarTyC = (value) => {
        if(value !== null && value !== undefined){
            setOpenConfirmacionTerminos(true);
            setValorMedioPago(value);
            
            return;
        }
        
        Swal.fire({
            title: 'Atención',
            html: `¿Está seguro que desea continuar?`,
            icon: 'warning',
            showCloseButton: false,
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(setEnvioConDeuda({
                    envioConDeuda: true,
                    monto: null
                }));
                setOpenConfirmacionTerminos(true);
                setValorMedioPago(value);
            }
        })
    }

    const continuarMedioDePago = () => {
        if(valorMedioPago !== null && valorMedioPago !== undefined) {
            setMedioDePago(valorMedioPago);
            setConfirmaPago(true);
            return;
        }

        if(tramiteTienePagoInicial){
            setTieneDiferenciaEnPago(false)
            setResultadoPago(true)
        }

        setMontarPdf(true);
        // enviarSolicitudSinPagar();
    }

    useEffect(() => {
        // if(!resultadoPagoTasa){
        if(tieneDiferenciaEnPago || !resultadoPagoTasa){
            calculoDeTasa();
        }
    }, [banderaOperacion])

    useEffect(() => {
        if ( tipoUsuario !== 1 && (tieneDiferenciaEnPago || !resultadoPagoTasa) && (idEstado === 1 || (idEstado === 6 && datos.Observado))) {
            Swal.fire({
                title: 'Atención',
                // html: `El pago debe realizarse <b>dentro del sistema</b>. Si se abandona la solicitud antes de abonar, la misma perderá vigencia.<br/><br/>Luego de efectuar el pago, <b>verifique que aparezca el mensaje “Su solicitud ha sido enviada”</b> y que el archivo se haya<br/>descargado correctamente.`,
                html: `
                    <div style="font-size: 1.4rem; line-height: 1.5;">
                    A continuación visualizará el importe del D.E.P. a abonar.<br/>
                    Recuerde que debe realizarlo sin salir de la pestaña medio de pago.<br/>
                    Seguidamente se mostrará el aviso "Su solicitud ha sido enviada" y el documento se descargará automáticamente.
                    </div>
                `,
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: false,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                allowOutsideClick: true,
                width: '75vw' 
            });
        }
    }, []);    

    if (loading) return (
        <Grid container justifyContent="center" alignItems="center" style={{ height: '100vh' }} >
            <CircularProgress />
        </Grid>
    );

    return (
    <Grid container>
        <Grid item md={12}>
            {
                estadoOperacion === 1 ? 
                <PagoPendiente obtenerResultadoDePago={obtenerResultadoDePago} setEstadoOperacion={setEstadoOperacion}/>
                :
                ((tieneDiferenciaEnPago || !resultadoPagoTasa) ? 
                    (() => {
                        switch(medioDePago) {
                            case "0":
                                return <SeleccionDeMedioDePago setMedioDePago={setMedioDePago} loaderBtnGuardar={loaderBtnGuardar} setLoaderBtnGuardar={setLoaderBtnGuardar} bloquearBtn={bloquearBtn} setValue={setValue} tasaRR={tasaRR} setTasaRR={setTasaRR} montarTyC={montarTyC}/>
                            case "1":
                                return <PagoBrick setResult={setResultadoPago} setMedioDePago={setMedioDePago} tasaRR={tasaRR} setBanderaOperacion={setBanderaOperacion} banderaOperacion={banderaOperacion} limpiarNotificaciones={limpiarNotificaciones} tieneDiferenciaEnPago={tieneDiferenciaEnPago} setTieneDiferenciaEnPago={setTieneDiferenciaEnPago} idEstado={idEstado} setAcabaDePagar={setAcabaDePagar}/>
                            case "2":
                                return <PagoQR setMedioDePago={setMedioDePago} setResult={setResultadoPago} tasaRR={tasaRR} setBanderaOperacion={setBanderaOperacion} banderaOperacion={banderaOperacion} limpiarNotificaciones={limpiarNotificaciones} contadorNotificacion={contadorNotificacion} debeGenerarNuevoQR={debeGenerarNuevoQR} tieneDiferenciaEnPago={tieneDiferenciaEnPago} setTieneDiferenciaEnPago={setTieneDiferenciaEnPago} idEstado={idEstado} setAcabaDePagar={setAcabaDePagar}/>
                        }
                    })()
                    : 
                    <PagoCompletado datos={datos} setDatos={setDatos} titulosProfesional={[]} bloquearBtn={bloquearBtn} setBloquearBtn={setBloquearBtn} setValue={setValue} setOcultarTabs={setOcultarTabs} loaderBtnGuardar={loaderBtnGuardar} setLoaderBtnGuardar={setLoaderBtnGuardar} idEstado={idEstado} setIdEstado={setIdEstado} ocultarContenido={ocultarContenido} setOcultarContenido={setOcultarContenido} resultadoPagoTasa={resultadoPagoTasa}  estadoOperacion={estadoOperacion} enviarSolicitud={enviarSolicitud} confirmarPagoYGenerarPDF={confirmarPagoYGenerarPDF} poseeDeuda={poseeDeuda} setResultadoPago={setResultadoPago} tramiteTienePagoInicial={tramiteTienePagoInicial} acabaDePagar={acabaDePagar} envioTramiteConDeuda={envioTramiteConDeuda}/>
                )
            }
        </Grid>
        <ModalTyCCancelacion  
            onClose={() => setOpenConfirmacionTerminos(false)}
            open={openConfirmarTerminos}
            onSuccess={continuarMedioDePago}
            setValue={setValue}
            tasaRR={tasaRR}
            setTasaRR={setTasaRR}
            valorMedioPago={valorMedioPago}
        />
    </Grid>
  )
}
